/* Homepage reveals. Deliberately tiny and library-free: the hero already pulls GSAP in,
   and these sections only need "fade up when you reach them". */
(function () {
  'use strict';
  if (window.d2wHomeReveal) return;                 // each section tags the script; run once
  window.d2wHomeReveal = true;

  function run() {
    var items = document.querySelectorAll('.d2w [data-d2w-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: .1 });
    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // sections added by the theme editor
  document.addEventListener('shopify:section:load', function () { window.d2wHomeReveal = false; run(); window.d2wHomeReveal = true; });
})();
